import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  gridListWrapper: {
    '&&': {
      [theme.breakpoints.down('tablet')]: {
        rowGap: SPACES.s,
        columnGap: SPACES.s,
        flexWrap: 'nowrap',
        flexDirection: 'column',
        justifyContent: 'center',

        minHeight: 100,
      },
      [theme.breakpoints.up('tablet')]: {
        rowGap: '2.5rem',
        columnGap: SPACES.xxxxxl,

        minHeight: 240,
      },
    },
  },
  box: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: SPACES.s,
      gap: SPACES.xs,

      height: '100%',
      width: '100%',
      maxWidth: 'inherit',
      borderRadius: '10px',
      boxShadow: 'none',
    },
  },
  cardWrapper: {
    '&&': {
      cursor: 'pointer',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: SPACES.s,
      gap: SPACES.xs,

      border: `1px solid ${theme.palette.custom.grey}`,
      borderRadius: '10px',
      boxShadow: 'none',
      transitionDuration: 200,

      height: '100%',
      [theme.breakpoints.down('tablet')]: {
        justifyContent: 'flex-start',
      },
      [theme.breakpoints.up('tablet')]: {
        width: 200,
        flexDirection: 'column',
      },
    },
    '&&:hover': {
      backgroundColor: theme.palette.custom.grey,
    },
  },
  suspensionButtonDesktop: {
    '&&': {
      [theme.breakpoints.down('tablet')]: {
        display: 'none',
      },
      [theme.breakpoints.up('tablet')]: {
        zIndex: 5,
        position: 'absolute',
        top: '2px',
        right: '2px',
      },
    },
  },
  suspensionButtonTablet: {
    '&&': {
      [theme.breakpoints.up('tablet')]: {
        display: 'none',
      },
    },
  },

  suspensionButtonActive: {
    '&&': {
      color: theme.palette.custom.warning,

      '&:hover': {
        color: theme.palette.custom.grey2,
      },
    },
  },
  suspensionButtonInactive: {
    '&&': {
      color: theme.palette.custom.grey2,

      '&:hover': {
        color: theme.palette.custom.warning,
      },
    },
  },
  cardImageWrapper: {
    '&&': {
      position: 'relative',
    },
  },
  cardImage: {
    '&&': {
      borderRadius: '50%',

      [theme.breakpoints.down('tablet')]: {
        width: 70,
        height: 70,
      },
      [theme.breakpoints.up('tablet')]: {
        height: 130,
        width: 130,
      },
    },
  },
  cardContent: {
    '&&': {
      padding: '0 !important',
      width: '100%',
      height: '100%',

      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '16px',
      display: 'flex',

      color: theme.palette.custom.darkBlue2,

      [theme.breakpoints.up('tablet')]: {
        flexDirection: 'column',
        padding: `${SPACES.xxxs} ${SPACES.xs} ${SPACES.xs}`,
      },
    },
  },
  cardName: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,

      lineHeight: 1.35,
      color: 'inherit',
      [theme.breakpoints.down('tablet')]: {
        fontSize: FONTS.SIZES.default,
      },
      [theme.breakpoints.up('tablet')]: {
        textAlign: 'center',
        fontSize: FONTS.SIZES.xxl,
      },
    },
  },
  buttonsWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      gap: SPACES.xxxs,
    },
  },

  addNewCardWrapper: {
    '&&': {
      height: '100%',

      backgroundColor: theme.palette.custom.secondary,

      borderRadius: '10px',
      boxShadow: 'none',

      [theme.breakpoints.down('tablet')]: {
        width: '100%',
        minHeight: 100,
      },
      [theme.breakpoints.up('tablet')]: {
        width: 200,
        minHeight: 200,
      },
    },
  },
  addNewCard: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '15px',

      padding: '15px 10px',

      '&:disabled': {
        backgroundColor: theme.palette.custom.grey,
        '& p': {
          color: theme.palette.custom.grey2,
        },
        '& svg': {
          color: theme.palette.custom.grey2,
        },
      },

      [theme.breakpoints.down('tablet')]: {
        minHeight: 100,
      },
      [theme.breakpoints.up('tablet')]: {
        minHeight: '100%',
      },
    },
  },
  addNewCardAction: {
    '&&': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      '&:disabled': {
        backgroundColor: theme.palette.custom.grey,
        '& p': {
          color: theme.palette.custom.grey2,
        },
        '& svg': {
          color: theme.palette.custom.grey2,
        },
      },
    },
  },

  addNewCardText: {
    '&&': {
      marginLeft: SPACES.xxxs,
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.33,
      textTransform: 'uppercase',

      color: theme.palette.custom.primary,
    },
  },

  addNewCardTextSecondary: {
    '&&': {
      fontWeight: 500,
      fontSize: '11px',
      textAlign: 'center',

      color: theme.palette.custom.grey2,
    },
  },

  imageButton: {
    '&&': {
      position: 'absolute',
      top: '3px',
      right: '3px',
      color: theme.palette.custom.white,
      padding: SPACES.xxxs,
      zIndex: 1000,

      [theme.breakpoints.down('tablet')]: {
        display: 'none',
      },
    },
  },

  moreButton: {
    '&&': {
      position: 'absolute',
      top: '40%',
      transform: 'translateY(-50%)',
      right: '3px',
      color: theme.palette.custom.darkBlue2,
      padding: SPACES.xxxs,
      zIndex: 1000,

      [theme.breakpoints.up('tablet')]: {
        display: 'none',
      },
    },
  },

  statusIcon: {
    '&&': {
      position: 'absolute',
      top: '3px',
      left: '3px',
      color: theme.palette.custom.white,
      padding: SPACES.xxxs,
      zIndex: 1000,

      [theme.breakpoints.down('tablet')]: {
        display: 'none',
      },
    },
  },
}))

export { useStyles }
